import axios from "axios";

export const listJudicialRecords = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_JUDICIAL_API_URL}/log/get-list`, data, { headers });
};

export const detailJudicialRecords = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_JUDICIAL_API_URL}/log/get-detail?id=${id}`, { headers });
};
